<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 2 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
              >
                {{ card.value }}
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-reg"
          routerLink="/marketing/social/contentRequests"
          >Content Requests
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          routerLink="/marketing/social/registry"
          >Social Registry
        </a>
      </div>
    </div>
  </div>

  <div class="row mb-4 mt-2 text-center">
    <div class="col-12">
      <div class="platform-cards-container">
        <!-- Instagram -->
        <div
          class="platform-card"
          [ngClass]="{ active: filters.platform === 'instagram' }"
          (click)="
            filters.platform =
              filters.platform === 'instagram' ? '' : 'instagram';
            applyFilters()
          "
        >
          <div class="platform-icon ig">
            <i class="fab fa-instagram"></i>
          </div>
          <span class="platform-name">Instagram</span>
        </div>

        <!-- Facebook -->
        <div
          class="platform-card"
          [ngClass]="{ active: filters.platform === 'facebook' }"
          (click)="
            filters.platform =
              filters.platform === 'facebook' ? '' : 'facebook';
            applyFilters()
          "
        >
          <div class="platform-icon fb">
            <i class="fab fa-facebook-f"></i>
          </div>
          <span class="platform-name">Facebook</span>
        </div>

        <!-- YouTube -->
        <div
          class="platform-card"
          [ngClass]="{ active: filters.platform === 'youtube' }"
          (click)="
            filters.platform = filters.platform === 'youtube' ? '' : 'youtube';
            applyFilters()
          "
        >
          <div class="platform-icon yt">
            <i class="fab fa-youtube"></i>
          </div>
          <span class="platform-name">YouTube</span>
        </div>

        <!-- TikTok -->
        <div
          class="platform-card"
          [ngClass]="{ active: filters.platform === 'tiktok' }"
          (click)="
            filters.platform = filters.platform === 'tiktok' ? '' : 'tiktok';
            applyFilters()
          "
        >
          <div class="platform-icon tt">
            <i class="fab fa-tiktok"></i>
          </div>
          <span class="platform-name">TikTok</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a class="btn btn-dark btn-sm btn-reg">STRATEGY </a>
        <a class="btn btn-dark btn-sm btn-new">SEMANTIKA </a>
        <a class="btn btn-dark btn-sm btn-new">PERFORMANCE </a>
      </div>
    </div>
  </div>

  <div class="card shadow-sm mb-4 mt-4">
    <div class="card-body">
      <div class="row pb-3">
        <div class="col-md-12">
          <a
            [routerLink]="['/marketing/social/contentRequests/add']"
            class="btn btn-dark btn-sm mt-0 btn-neww"
          >
            NEW
          </a>
        </div>
      </div>
      <div class="row g-3">
        <div class="col-md-2">
          <label class="form-label small fw-bold d-block">Status</label>
          <select
            class="form-select form-select-sm"
            [(ngModel)]="filters.status"
            (change)="applyFilters()"
          >
            <option value="">All</option>
            <option value="new">New</option>
            <option value="in_progress">In Progress</option>
            <option value="fulfilled">Fulfilled</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>

        <div class="col-md-3">
          <label class="form-label small fw-bold d-block">Purpose</label>
          <select
            class="form-select form-select-sm"
            [(ngModel)]="filters.purpose"
            (change)="applyFilters()"
          >
            <option value="">All</option>
            <option value="evergreen">Evergreen</option>
            <option value="promo">Promo</option>
            <option value="trust">Trust</option>
            <option value="geo">Geo</option>
            <option value="industry">Industry</option>
            <option value="service">Service</option>
            <option value="refresh">Refresh</option>
            <option value="campaign_support">Campaign Support</option>
          </select>
        </div>

        <div class="col-md-2">
          <label class="form-label small fw-bold d-block">Vertical</label>
          <select
            class="form-select form-select-sm"
            [(ngModel)]="filters.vertical"
            (change)="applyFilters()"
          >
            <option value="">All</option>
            <option value="courier">Courier</option>
            <option value="task_runner">Task Runner</option>
            <option value="bridge">Bridge</option>
          </select>
        </div>

        <div class="col-md-5 d-flex align-items-end justify-content-end gap-2">
          <div class="input-group input-group-sm">
            <input
              type="text"
              class="form-control"
              placeholder="Request ID or Notes..."
              [(ngModel)]="searchText"
              (ngModelChange)="applyFilters()"
              list="suggestionsRequest"
              autocomplete="off"
            />
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div>
          <datalist id="suggestionsRequest">
            <option
              *ngFor="let suggestion of searchSuggestions"
              [value]="suggestion"
            ></option>
          </datalist>
        </div>
      </div>
    </div>
  </div>

  <div class="card shadow-sm">
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-bordered table-striped">
          <thead class="thead">
            <tr>
              <th>Request ID</th>
              <th>Requested By</th>
              <th>Purpose</th>
              <th>Vertical</th>
              <th>Platforms</th>
              <th>Status</th>
              <th>Due Date</th>
              <th>Notes</th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of filteredData">
              <td
                class="url-cell"
                (click)="showModal('Request ID', item.request_id)"
                title="Click to view full Request ID"
              >
                {{ item.request_id }}
              </td>
              <td>
                <span class="badge badge-secondary">{{
                  item.requested_by_type | uppercase
                }}</span>
              </td>
              <td>{{ item.purpose | uppercase }}</td>
              <td>{{ item.vertical | uppercase }}</td>
              <td>
                <div class="d-flex flex-wrap gap-1">
                  <span
                    *ngFor="let platform of item.requested_platforms"
                    class="badge badge-dark small"
                  >
                    {{ platform }}
                  </span>
                </div>
              </td>
              <td>
                <span
                  class="badge w-100"
                  [ngClass]="{
                    'badge-info': item.status === 'new',
                    'badge-warning': item.status === 'in_progress',
                    'badge-success': item.status === 'fulfilled',
                    'badge-danger': item.status === 'cancelled',
                  }"
                >
                  {{ item.status | uppercase }}
                </span>
              </td>
              <td>{{ item.due_date | date: "shortDate" }}</td>
              <td>
                <small class="text-muted">{{ item.notes }}</small>
              </td>
              <td class="text-center">
                <a
                  class="btn btn-link text-dark btn-sm"
                  [routerLink]="[
                    '/marketing/social/contentRequests/edit',
                    item._id,
                  ]"
                  title="Edit"
                >
                  <i class="fas fa-pen"></i>
                </a>

                <button
                  (click)="generateAssets(item._id)"
                  class="btn btn-link text-primary btn-sm"
                  title="Generate Assets"
                  *ngIf="item.status === 'new' || item.status === 'in_progress'"
                >
                  <i class="fas fa-magic"></i>
                </button>

                <button
                  (click)="deleteData(item._id)"
                  class="btn btn-link text-danger btn-sm"
                  title="Delete"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div class="modal-url-overlay" *ngIf="modalContent" (click)="closeModal()">
  <div class="modal-url-content" (click)="$event.stopPropagation()">
    <div class="modal-url-header">
      <h5 class="mb-0">{{ modalTitle }}</h5>
      <button type="button" class="modal-url-close" (click)="closeModal()">
        &times;
      </button>
    </div>
    <div
      class="modal-url-body text-dark"
      style="word-wrap: break-word; white-space: pre-wrap"
    >
      {{ modalContent }}
    </div>
  </div>
</div>
